import { Injectable } from '@angular/core';
import {
  ConfirmCashOutRepository
} from '@private/modules/cash-out-payment/core/repositories/confirm-cash-out/confirm-cash-out.repository';
import { ApiService } from '@nequi/design-system-lib/logic';
import {
  ConfirmCashOutRequestEntity,
  ConfirmCashOutResponseEntity
} from '@private/modules/cash-out-payment/core/entities';
import { ApiHeaderGenerateService } from '@shared/services/api-header-generate/api-header-generate.service';
import { Response } from '@private/modules/cash-out-payment/core/entities/response.entity';

@Injectable()
export class ConfirmCashOutImplRepository implements ConfirmCashOutRepository {

  constructor(private readonly apiService: ApiService,
              private readonly apiHeaderGenerateService: ApiHeaderGenerateService) {
  }

  public async confirmTransaction(params: ConfirmCashOutRequestEntity): Promise<ConfirmCashOutResponseEntity> {
    const headers = this.apiHeaderGenerateService.generateAuthHeaders();
    const response = await this.apiService
      .put<Response<ConfirmCashOutResponseEntity>>('cashout/confirmation', params, { headers });
    return response.data;
  }

}
